<template>
  <div class="pages">
    <div class="btns">
      <div class="prev iconfont icon-jiantou-copy" :class="{ none: activeIndex == 1 }" @click="activeIndex -= 1"></div>
      <div v-for="(item, index) in last" :key="index" :class="{ active: activeIndex == item }"
        @click="activeIndex = item">
        {{ item }}
      </div>
      <div class="next iconfont icon-jiantou" :class="{ none: activeIndex == last }" @click="activeIndex += 1"></div>
    </div>
    <div class="input">
      To
      <input type="number" v-model="text" @change="inputChange" />
      Page
    </div>
  </div>
</template>

<script>
export default {
  props: {
    last: {
      type: Number,
    },
  },
  data() {
    return {
      text: "",
      // last: 4,
      activeIndex: 1,
    };
  },
  methods: {
    inputChange(e) {
      let number = e.target.value;
      if (number >= 1 && number <= this.last && number != this.activeIndex) {
        this.activeIndex = number;
        this.text = "";
      }
    },
  },
  watch: {
    activeIndex(newVal) {
      this.$emit("numberChange", newVal);
    },
  },
};
</script>

<style lang="less" scoped>
.pages {
  margin-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;

  .btns {
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 32px;
      height: 32px;
      background: #f6f6f8;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s;

      &.prev.none,
      &.next.none {
        pointer-events: none;
        color: #999;
      }

      &.active,
      &:hover {
        color: #fff;
        background: var(--themeColor2);
      }

      &+div {
        margin-left: 10px;
      }
    }
  }

  .input {
    margin-left: 20px;

    input {
      width: 1em;
      border: 1px solid #eee;
      border-radius: 0;
      padding: 3px 10px;
      margin: 0 3px;
    }
  }
}

@media (max-width: 700px) {
  .pages {
    margin-top: 50px;
  }
}
</style>